import { render, staticRenderFns } from "./SupportPanel.vue?vue&type=template&id=2a1760d1&scoped=true&"
import script from "./SupportPanel.vue?vue&type=script&lang=ts&"
export * from "./SupportPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SupportPanel.vue?vue&type=style&index=0&id=2a1760d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1760d1",
  null
  
)

export default component.exports